const state = {
  id: null,
  orderable_id: undefined,
  orderable_type: '',
  provider_id: undefined,
  unit: 'days',
  value: '',
}

export const requiredFields = [
  { key: 'orderable_id' },
  { key: 'orderable_type' },
  { key: 'provider_id' },
  { key: 'unit' },
  { key: 'value' },
]

export default state
